var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_17103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 0H10.0844C9.76077 0 9.49845 0.262324 9.49845 0.585938C9.49845 0.909551 9.76077 1.17188 10.0844 1.17188H12.9995L8.30261 5.86881C8.07377 6.09765 8.07377 6.46863 8.30261 6.69744C8.53142 6.92625 8.9024 6.92628 9.13124 6.69744L13.8282 2.00051V4.91563C13.8282 5.23925 14.0905 5.50157 14.4141 5.50157C14.7377 5.50157 15.0001 5.23925 15.0001 4.91563V0.585938C15.0001 0.267041 14.7409 0 14.4141 0Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69744 8.30248C6.4686 8.07367 6.09762 8.07364 5.86881 8.30248L1.17188 12.9994V10.0843C1.17188 9.76067 0.909551 9.49835 0.585938 9.49835C0.262324 9.49835 0 9.76067 0 10.0843V14.414C0 14.7323 0.259365 14.9999 0.585938 14.9999H4.91566C5.23928 14.9999 5.5016 14.7376 5.5016 14.414C5.5016 14.0904 5.23928 13.828 4.91566 13.828H2.00051L6.69744 9.13111C6.92628 8.90227 6.92628 8.53129 6.69744 8.30248Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_17103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.e25d98e69b50a46e58d034a9954f7287.svg";
export { ForwardRef as ReactComponent };